import { Typography } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const CollapseBodyHeader = () => {
  const headerStyles = {
    color: '#808080',
    fontSize: 16,
    fontWeight: 600,
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 0',
        background: COLOR_CONFIG.doctor,
        borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
      }}
    >
      <Typography style={{ ...headerStyles, width: 48, paddingLeft: 8 }}>#</Typography>
      <Typography style={{ ...headerStyles, flexGrow: 1, width: 0 }}>Functional test</Typography>
      <Typography style={{ ...headerStyles, width: 150 }}>Score</Typography>
      <Typography style={{ ...headerStyles, width: 321 }}>Metric</Typography>
      <div style={{ width: 40 }}></div>
    </div>
  );
};
